import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFlashMessage } from "@/app/(main)/(club)/mes-clubs/[id]/components/use-flash-message";
import { useModalStore } from "@/stores/modal-store";
import { ApiWriteResponse, EventRead } from "@/TS/Interfaces/global_interfaces";
interface TransformedEventData {
  agenda: string;
  absentMembers: string[];
}
interface MutationParams {
  data: TransformedEventData;
  type: string;
  clubSlug: string;
  startDate: string;
}
export const useEventMutation = () => {
  const $ = _c(10);
  const {
    close
  } = useModalStore();
  const queryClient = useQueryClient();
  const {
    showFlashMessage
  } = useFlashMessage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["event"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== queryClient || $[2] !== showFlashMessage) {
    t1 = async (_, variables) => {
      const queryToInvalidate = ["clubEvent", variables.type, variables.clubSlug, variables.startDate?.split("T")[0]];
      await queryClient.invalidateQueries({
        queryKey: queryToInvalidate,
        exact: true,
        refetchType: "all"
      });
      await queryClient.refetchQueries({
        queryKey: queryToInvalidate,
        exact: true,
        type: "all"
      });
      showFlashMessage("La modification a \xE9t\xE9 appliqu\xE9e avec succ\xE8s !", "success2", "mes-clubs-calendar");
    };
    $[1] = queryClient;
    $[2] = showFlashMessage;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== close || $[5] !== showFlashMessage) {
    t2 = _error => {
      close();
      showFlashMessage("Une erreur est survenue lors de la modification", "primary", "mes-clubs-calendar");
    };
    $[4] = close;
    $[5] = showFlashMessage;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = {
      mutationKey: t0,
      mutationFn: _temp,
      onSuccess: t1,
      onError: t2
    };
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return useMutation(t3);
};
async function _temp(t0) {
  const {
    data,
    type,
    clubSlug,
    startDate
  } = t0;
  const response = await fetch(`/api/update-event?type=${type}&clubSlug=${clubSlug}&startDate=${startDate}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  });
  if (!response.ok) {
    throw new Error("Erreur lors de la mise \xE0 jour de l'\xE9v\xE9nement");
  }
  return response.json();
}